import { useState } from "react";
import { useTranslation } from "react-i18next";

import TkAgreementManagementExelUploadDialog from "../dialogTypes/TkAgreementManagementExelUploadDialog";
import ActionButtonLayout from "../layout/ActionButtonLayout";

// import { cloneDeep } from "lodash";

function TkAgreementManagementExelUploadButton(props) {

    const { t } = useTranslation();

    const { id, schema, grid, refresh, onSuccess, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();
    // const [tableSchema, setTableSchema] = useState();


    // useEffect(() => {
    //     if (schema) {
    //         let newSchema = cloneDeep(schema);
    //         for (let column of newSchema.columns) {
    //             column.hideInForm = true;
    //         }
    //         newSchema.columns.push({ name: "excelFile" })
    //         console.log(newSchema)
    //         setTableSchema(newSchema)
    //     }
    // }, [schema]);

    const onOpen = () => {

        if (grid) {

            setFormData({ ...(grid.selectedItems[0]) });

        }

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onUpdateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };

    return (

        <>
            <ActionButtonLayout onClick={onOpen} {...others}>{t("buttonName.excelUpload")}</ActionButtonLayout>
            <TkAgreementManagementExelUploadDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${schema.name}.excelUpload`) : ""}
                schema={schema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default TkAgreementManagementExelUploadButton;

